import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_FORECAST_BILL_AZURE,
  GET_FORECAST_BILL_AZURE_SUCCESS,
  GET_FORECAST_BILL_AZURE_ERROR,
  GET_DAILY_FORECAST_BILL_AZURE,
  GET_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_RESOURCEGROUP_FORECAST_BILL_AZURE,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR,
  GET_LOCATION_FORECAST_BILL_AZURE,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS,
  GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR,
} from "./constant";

import {
  getAzureForecastBillApi,
  getAzureDailyForecastBillApi,
  getAzureResourceGroupForecastBillApi,
  getAzureLocationForecastBillApi,
} from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const response = yield call(getAzureForecastBillApi, params, provider);
    const data = response?.data || response;
    yield put({ type: GET_FORECAST_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_FORECAST_BILL_AZURE_ERROR, error });
  }
}

function* getAzureLocationForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const response = yield call(getAzureLocationForecastBillApi, params, provider);
    const data = response?.data || response;
    yield put({ type: GET_LOCATION_DAILY_FORECAST_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_LOCATION_DAILY_FORECAST_BILL_AZURE_ERROR, error });
  }
}

function* getAzureDailyForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const response = yield call(getAzureDailyForecastBillApi, params, provider);
    const data = response?.data || response;
    yield put({ type: GET_DAILY_FORECAST_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_DAILY_FORECAST_BILL_AZURE_ERROR, error });
  }
}

function* getAzureResourceGroupForecastBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const response = yield call(getAzureResourceGroupForecastBillApi, params, provider);
    const data = response?.data || response;
    yield put({
      type: GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_RESOURCEGROUP_DAILY_FORECAST_BILL_AZURE_ERROR,
      error,
    });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureForecastBillSaga() {
  yield takeLatest(GET_FORECAST_BILL_AZURE, getAzureForecastBillList);
  yield takeLatest(
    GET_DAILY_FORECAST_BILL_AZURE,
    getAzureDailyForecastBillList
  );
  yield takeLatest(
    GET_RESOURCEGROUP_FORECAST_BILL_AZURE,
    getAzureResourceGroupForecastBillList
  );
  yield takeLatest(
    GET_LOCATION_FORECAST_BILL_AZURE,
    getAzureLocationForecastBillList
  );
}
